import { PROCESS_UPDATE, PROCESS_SET_PROGRESS } from '../constants'

export function actionProcessUpdate(server, user, isRunning) {
    return {
        type: PROCESS_UPDATE,
        payload: {
            server,
            user,
            isRunning,
        },
    }
}

export function actionProcessSetProgress(server, user, progress) {
    return {
        type: PROCESS_SET_PROGRESS,
        payload: {
            server,
            user,
            progress,
        },
    }
}



// WEBPACK FOOTER //
// ./src/actions/process.js